// Gold
export default [
    {type: "freeplay", to: "$5"},
    {type: "weekly_rakeback", to: "10%"},
    {type: "monthly_rakeback", to: "7%"},
    {type: "birthday_bonus", to: "$15 + 15%"},
    {type: "deposit_assist_token", to: "$1.5"}
]